import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiFormGroup = {
  styleOverrides: { root: { gap: '16px' } },
} satisfies Components<Theme>['MuiFormGroup'];
